// @flow
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';


import { disconnect } from '../../../base/connection';
import { openDialog } from '../../../base/dialog';
import { Icon, IconHangup } from '../../../base/icons';
import { kickParticipant } from '../../../base/participants';

import { AlertBox } from './AlertBox';
import { colorsHangup } from './Constants';

// type particpantObject = {
//         id: string | undefined | null;
//         accessToken: string | null | undefined;
//         audioOutputDeviceId: string | null | undefined;
//         avatarURL: string | null | undefined;
//         botType: undefined | string;
//         conference: undefined | Object;
//         connectionStatus: undefined | string;
//         dominantSpeaker: boolean;
//         email: string;
//         features: Object;
//         isFakeParticipant: undefined | boolean;
//         isJigasi: undefined | null | boolean;
//         loadableAvatarUrl: undefined | null | string;
//         local: boolean;
//         name: string | null | '' | undefined;
//         pinned: boolean | null | undefined;
//         presence: undefined | null | boolean;
//         role: string | undefined | null;
//         startWithAudioMuted: boolean | undefined | null;
//         startWithVideoMuted: boolean | undefined | null;
// }


const styles = {
    mainView: {
        backgroundColor: colorsHangup.blackColor,
        padding: '10% 5% 10% 5%'
    },
    centerText: {
        color: colorsHangup.white,
        textAlign: 'center',
        fontSize: 16,
        fontWeight: '600'
    },
    fivepPadding: {
        padding: '5%'
    },
    hangUpEveryOne: {
        backgroundColor: colorsHangup.hangUpRed,
        borderRadius: 12,
        margin: '5px 5px 5px 5px',
        padding: '7px',
        cursor: 'pointer'
    },
    hangUpAlone: {
        backgroundColor: colorsHangup.hangUpBlue,
        borderRadius: 12,
        margin: '5px 5px 10px 5px',
        padding: '7px',
        cursor: 'pointer'
    },
    whiteColor: {
        color: colorsHangup.white
    },
    rowFlex: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%'
    },
    paddingLeftAndRight: {
        paddingLeft: 5,
        paddingRight: 5
    }
};

type Props = {
    onLeaveEveryOne: ?Function
}


export const HangupContent = (props: Props) => {
    const { onLeaveEveryOne } = props;
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const partipicipantss = useSelector(state => state['features/base/participants']);
    const isRemoteParticipants = partipicipantss.filter(it => it.local !== true);
    const howManyModerators = partipicipantss.filter(it => it.role === 'moderator');

    const onJustHangUp = React.useCallback((isTrue = false) => {
        if (howManyModerators.length <= 1 && !isTrue) {
            dispatch(openDialog(AlertBox, {
                alertText: 'Are you sure you want to exit without making someone else as Moderator?',
                disableOverlay: false,
                submitDisabled: false,
                cancelDisabled: false,
                onSubmit: () => onJustHangUp(true),
                okKey: 'End Anyway'
            }));

            return;
        }

        dispatch(disconnect(false));
    }, [ dispatch ]);


    const onRemoveEveryOneAndLeave = React.useCallback(() => {
        onLeaveEveryOne(true);
        for (let index = 0; index < isRemoteParticipants.length; index++) {
            hitFunc(index);
        }

    }, [ dispatch ]);


    // React.useEffect(() => {
    //     if (isRemoteParticipants.length === 0 && isLeaving) {
    //         dispatch(disconnect(false));
    //     }
    // }, [, isRemoteParticipants?.length ]);


    /**
         * Function for Loop.
         *
         * @param {any} index - Index.
         * @returns {any}
         */
    function hitFunc(index) {
        setTimeout(() => {
            const element = isRemoteParticipants[index];
            const tranlated = t('dialog.hangUpLeaveReason');

            dispatch(kickParticipant(element.id, tranlated));
        }, index * 300);
    }

    return (

        <div className = 'audio-preview-content'>
            <div style = { styles.mainView }>
                <div
                // eslint-disable-next-line react/jsx-no-bind
                    onClick = { () => onJustHangUp(false) }
                    style = { styles.hangUpAlone }>
                    <div
                        style = {
                            styles.rowFlex
                        }>
                        <div style = { styles.paddingLeftAndRight }>
                            <Icon src = { IconHangup } />

                        </div>
                        <div style = { styles.paddingLeftAndRight } >
                            <span style = { styles.whiteColor }>
                                {t('toolbar.hangUpforMe')}
                            </span>

                        </div>
                    </div>
                </div>
                {
                    Array.isArray(isRemoteParticipants) && isRemoteParticipants.length > 0
                    && <div
                        onClick = { onRemoveEveryOneAndLeave }
                        style = { styles.hangUpEveryOne }>
                        <div
                            style = {
                                styles.rowFlex
                            }>
                            <div style = { styles.paddingLeftAndRight } >
                                <Icon src = { IconHangup } />

                            </div>
                            <div style = { styles.paddingLeftAndRight } >
                                <span style = { styles.whiteColor }>
                                    {t('toolbar.hangUpforEveryOne')}
                                </span>

                            </div>
                        </div>
                    </div>
                }
            </div></div>

    );
};
